import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireAnyPermission, requireModules } from '../../route';
import { newRuleSetCrumbs } from './exceptionRuleSetCrumbs';

const ExceptionRuleSetEditorPage = lazyRouteComponent(
  () => import('./ExceptionRuleSetEditorPage'),
  'ExceptionRuleSetEditorPage',
);

function NewExceptionRuleSetPage() {
  return (
    <ExceptionRuleSetEditorPage key="new" ruleSet={null} routeId={Route.id} />
  );
}

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/exception-rules/new',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Create, subject: Subject.APExceptionRuleSet },
        ],
      },
    },
  },
  component: NewExceptionRuleSetPage,
  loader: () => newRuleSetCrumbs(),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Create, subject: Subject.APExceptionRuleSet },
      ],
    });
  },
});
